import TokensDetail from "./detail";

export default TokensDetail;
